import { render, staticRenderFns } from "./accountMgt.vue?vue&type=template&id=b6e1c674&scoped=true&"
import script from "./accountMgt.vue?vue&type=script&lang=js&"
export * from "./accountMgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e1c674",
  null
  
)

export default component.exports